// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Qpjh","notes":"Notes_notes__1X7NA","note":"Notes_note__1AfF7","markdown":"Notes_markdown__A3jxO"};